var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"layout-container flex-center"},[_c('Header'),_c('el-container',{staticClass:"layout-mian-height-50"},[_c('Aside'),_c('div',{staticClass:"flex-center layout-backtop"},[(_vm.isTagsview)?_c('TagsView'):_vm._e(),_c('Main')],1)],1),_c('el-backtop',{attrs:{"target":".layout-backtop .el-main .el-scrollbar__wrap"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }